import { Bullet } from "./bullet";
import { Weapon } from "./weaponPickup";
import { Zombie } from "./zombie";
import { Doors } from "./doors";
import * as bulletData from "./bulletData.json";
import { Maps } from "./maps"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference

// TODO add lasergun TODO hitscan
// TODO bouncing ammo
// TODO freeze
// TODO spazer
// TODO UI for delay between shots
// TODO reloading?
// TODO spawn bullets away from player

export class Bullets {
	self: Phaser.Physics.Arcade.Group;
	selectedAmmo: string;
	// ammo: object = {
	// 	basic: Basic,
	// 	mg: MG
	// };
	lastShotTime = 0;
	explosions = false;
	explosionLocation = { x: 0, y: 0 };
	specialAmmo = 0;
	specialWeapon = "";

	sounds: { [id: string]: Phaser.Sound.BaseSound };

	constructor() // world: Phaser.Physics.Arcade.World,
	// scene: Phaser.Scene
	{
		// super(world, scene, {
		// 	classType: Zombie,
		// 	runChildUpdate: true,
		// });
	}

	preload(scene: Phaser.Scene): void {
		// load bullet sprites here
		// scene.load.image("bullet", "assets/bullet6.png");
		// scene.load.image("bulletsmall", "assets/bullet5.png");
		// scene.load.spritesheet("flame", "assets/flame-16x_extruded.png", {
		// 	frameWidth: 16,
		// 	frameHeight: 16,
		// 	margin:1,
		// 	spacing:2
		// });
		// scene.load.spritesheet("explode3", "assets/explode3.png", {
		// 	frameWidth: 48,
		// 	frameHeight: 48,
		// 	margin:1,
		// 	spacing:2
		// });

		// SOUND!
		scene.load.audio("bullet1", ["release_assets/sound/bullet1.wav"]);
		scene.load.audio("bullet2", ["release_assets/sound/bullet2.wav"]);
		scene.load.audio("bullet3", ["release_assets/sound/bullet3.wav"]);
		scene.load.audio("minigun1", ["release_assets/sound/minigun1.wav"]);
		scene.load.audio("minigun2", ["release_assets/sound/minigun2.wav"]);
		scene.load.audio("minigun3", ["release_assets/sound/minigun3.wav"]);
		scene.load.audio("fire1", ["release_assets/sound/fire1.wav"]);
		scene.load.audio("fire2", ["release_assets/sound/fire2.wav"]);
		scene.load.audio("fire3", ["release_assets/sound/fire3.wav"]);
		scene.load.audio("mine", ["release_assets/sound/mine.wav"]);
		scene.load.audio("explosion", ["release_assets/sound/explosion.wav"]);
		scene.load.audio("rocket", ["release_assets/sound/rocket.wav"]);
		scene.load.audio("hurt1", ["release_assets/sound/hurt1.wav"]);
		scene.load.audio("hurt2", ["release_assets/sound/hurt2.wav"]);
		scene.load.audio("hurt3", ["release_assets/sound/hurt3.wav"]);

		scene.load.audio("shotgun1", ["release_assets/sound/shotgun1.wav"]);

	}

	create(
		scene: Phaser.Scene,
		zombies: Phaser.Physics.Arcade.Group,
		map: Maps,
		doors: Doors
	): void {
		const burnFrameNames = scene.anims.generateFrameNames("sprites", {
			start: 0,
			end: 8,
			zeroPad: 1,
			prefix: "split/flame-16x-",
			suffix: ".png"
		});
		scene.anims.create({ key: "burn", frames: burnFrameNames, frameRate: 20, repeat: -1 });
		const explodeFrameNames = scene.anims.generateFrameNames("sprites", {
			start: 0,
			end: 8,
			zeroPad: 1,
			prefix: "split/explode3-",
			suffix: ".png"
		});
		scene.anims.create({ key: "explode", frames: explodeFrameNames, frameRate: 20, repeat: 0 });
		// scene.anims.create({
		// 	key: "burn",
		// 	frames: scene.anims.generateFrameNumbers("flame", {
		// 		start: 0,
		// 		end: 8
		// 	}),
		// 	frameRate: 20,
		// 	repeat: -1
		// });
		// scene.anims.create({
		// 	key: "explode",
		// 	frames: scene.anims.generateFrameNumbers("explode3", {
		// 		start: 0,
		// 		end: 8
		// 	}),
		// 	frameRate: 20,
		// 	repeat: 0
		// });
		const json: { [index: string]: BulletJSON } = bulletData;
		// looks like we need a new "bullet(singular)" class for each different type of bullet!
		this.self = scene.physics.add.group({
			classType: Bullet,
			runChildUpdate: true
		});
		this.selectedAmmo = "basic";
		this.specialAmmo = json[this.selectedAmmo].ammo;

		this.self.maxSize = json[this.selectedAmmo].maxBullets;

		const config: Phaser.Types.Sound.SoundConfig = {
			volume: 0.1
		};
		this.sounds = {};
		this.sounds["shotgun1"] = scene.sound.add("shotgun1", config);
		// this.sounds["shotgun2"] = scene.sound.add("shotgun2", config);
		// this.sounds["lazer"] = scene.sound.add("lazer", config);
		this.sounds["fire1"] = scene.sound.add("fire1", config);
		this.sounds["fire2"] = scene.sound.add("fire2", config);
		this.sounds["fire3"] = scene.sound.add("fire3", config);
		this.sounds["bullet1"] = scene.sound.add("bullet1", config);
		this.sounds["bullet2"] = scene.sound.add("bullet2", config);
		this.sounds["bullet3"] = scene.sound.add("bullet3", config);
		this.sounds["minigun1"] = scene.sound.add("minigun1", config);
		this.sounds["minigun2"] = scene.sound.add("minigun2", config);
		this.sounds["minigun3"] = scene.sound.add("minigun3", config);
		this.sounds["explosion"] = scene.sound.add("explosion", config);
		this.sounds["mine"] = scene.sound.add("mine", config);
		this.sounds["rocket"] = scene.sound.add("rocket", config);
		this.sounds["hurt1"] = scene.sound.add("hurt1", config);
		this.sounds["hurt2"] = scene.sound.add("hurt2", config);
		this.sounds["hurt3"] = scene.sound.add("hurt3", config);

		scene.physics.add.overlap(this.self, zombies, this.bulletZombieCollision, undefined, this);
		scene.physics.add.collider(
			this.self,
			map.collision,
			this.bulletPhysicsCollision,
			undefined,
			this
		);
		scene.physics.add.collider(
			this.self,
			doors.self,
			this.bulletPhysicsCollision,
			undefined,
			this
		);
	}

	update(
		time: number,
		delta: number,
		scene: Phaser.Scene,
		player: Phaser.Physics.Arcade.Sprite,
		keyboardInput: KeyboardInput,
		activePointer: Phaser.Input.Pointer
	): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		if (
			activePointer.isDown &&
			/*keyboardInput.space.isDown*/ this.lastShotTime + json[this.selectedAmmo].delay < time
		) {
			this.lastShotTime = time;
			this.fireBullets(this.selectedAmmo, scene, player, activePointer);

			if (this.specialAmmo > 0) {
				this.specialAmmo -= 1;
			}
			// If that actually WAS the last shot, swap the weapon back
			if (this.specialAmmo <= 0 && this.selectedAmmo !== "basic") {
				// this.selectedAmmo = Phaser.Utils.Array.GetRandom([
				// 	"mg",
				// 	"minigun",
				// 	"flamethrower",
				// 	"basic",
				// 	"shotty",
				// 	"mine",
				// 	"rocket"
				// ]);
				this.selectedAmmo = "basic";
				this.self.maxSize = json[this.selectedAmmo].maxBullets;
				this.lastShotTime = time;
				this.specialAmmo = json[this.selectedAmmo].ammo;
			}
		}

		if (this.explosions === true) {
			this.explosions = false;
			this.fireBullets(
				"explosion",
				scene,
				this.explosionLocation as Phaser.Physics.Arcade.Sprite,
				activePointer
			);
		}

		// if (keyboardInput.q.isDown && this.lastShotTime + 1000 < time) {
		// 	this.selectedAmmo = Phaser.Utils.Array.GetRandom([
		// 		"mg",
		// 		"minigun",
		// 		"flamethrower",
		// 		"basic",
		// 		"shotty",
		// 		"mine",
		// 		"rocket"
		// 	]);
		// 	this.self.maxSize = json[this.selectedAmmo].maxBullets;
		// 	this.lastShotTime = time;
		// 	this.specialAmmo = json[this.selectedAmmo].ammo;
		// }
	}

	fireBullets(
		selectedAmmo: string,
		scene: Phaser.Scene,
		player: Phaser.Physics.Arcade.Sprite,
		activePointer: Phaser.Input.Pointer
	): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		const soundToPlay: string = Phaser.Utils.Array.GetRandom(
			json[selectedAmmo].sounds
		) as string;
		// TODO F with sound?
		this.sounds[soundToPlay].play();
		if (json[selectedAmmo].shake) {
			scene.cameras.main.shake(50, 0.005);
		}
		let i: number;
		for (i = 0; i < json[selectedAmmo].bulletsPerShot; i = i + 1) {
			const bullet: Bullet = this.self.get() as Bullet;
			if (bullet) {
				if (selectedAmmo === "flamethrower") {
					bullet.anims.play("burn", true);
				} else if (selectedAmmo === "explosion") {
					bullet.anims.play("explode", false, 0);
				} else {
					bullet.anims.stop();
				}

				bullet.setActive(true).setVisible(true);
				activePointer.updateWorldPoint(scene.cameras.main);
				bullet.create(selectedAmmo, scene, player, {
					x: activePointer.worldX,
					y: activePointer.worldY
				});
			}
		}
	}

	getAmmoCount(): number {
		return this.specialAmmo;
	}

	getCurrentGun(): string {
		return this.selectedAmmo;
	}

	getNewWeapon(newWeaponName: string): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		// Check valitidy?
		this.selectedAmmo = newWeaponName;
		this.self.maxSize = json[this.selectedAmmo].maxBullets;
		this.specialAmmo = json[this.selectedAmmo].ammo;
	}

	// `(bullet: Phaser.Physics.Arcade.Sprite, zombie: Zombie)=> void` is a typedef
	private bulletPhysicsCollision(bullet: Bullet, zombie: Zombie): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		if (bullet.active === true) {
			// zombie.health -= json[myself.selectedAmmo].damage;
			// zombie.setHitstun(30, 0.2, bullet.rotation);
			if (json[bullet.bulletType]["explosion?"]) {
				this.explosions = true;
				this.explosionLocation.x = bullet.x;
				this.explosionLocation.y = bullet.y;
			}
			if (json[bullet.bulletType].destroyOnHit) {
				bullet.setActive(false).setVisible(false);
				bullet.x = -100;
				bullet.y = -100;
				bullet.setVelocity(0, 0);
			}
		}
		// handle bullet collision
	}

	private bulletZombieCollision(bullet: Bullet, zombie: Zombie): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		if (bullet.active === true) {
			zombie.setHitstun(
				json[bullet.bulletType].stunTime,
				json[bullet.bulletType].stunDistance,
				bullet.rotation,
				json[bullet.bulletType].damage,
				json[bullet.bulletType].iframes
			);
			if (json[bullet.bulletType]["explosion?"]) {
				this.explosions = true;
				this.explosionLocation.x = bullet.x;
				this.explosionLocation.y = bullet.y;
			}

			if (json[bullet.bulletType].destroyOnHit) {
				bullet.setActive(false).setVisible(false);
				bullet.x = -100;
				bullet.y = -100;
				bullet.setVelocity(0, 0);
			}
		}
		// handle bullet collision
	}
}
